import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { authService } from '../services/authService';
import GlobalHeader from '../components/GlobalHeader';
import './ProfilePage.css';

function ProfilePage() {
    const { user, updateProfile } = useAuth();
    const [editMode, setEditMode] = useState(false);
    const [formData, setFormData] = useState({
        firstName: user?.first_name || '',
        lastName: user?.last_name || ''
    });
    const [passwordData, setPasswordData] = useState({
        current: '',
        new: '',
        confirm: ''
    });
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [passwordLoading, setPasswordLoading] = useState(false);

    const handleProfileSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');
        setLoading(true);

        try {
            await authService.updateProfile(formData.firstName, formData.lastName);
            updateProfile({ first_name: formData.firstName, last_name: formData.lastName });
            setMessage('Profil mis à jour avec succès');
            setEditMode(false);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const handlePasswordSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');

        if (passwordData.new !== passwordData.confirm) {
            setError('Les nouveaux mots de passe ne correspondent pas');
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return;
        }

        if (passwordData.new.length < 8) {
            setError('Le mot de passe doit contenir au moins 8 caractères');
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return;
        }

        setPasswordLoading(true);

        try {
            await authService.changePassword(passwordData.current, passwordData.new);
            setMessage('Mot de passe changé avec succès!');
            setPasswordData({ current: '', new: '', confirm: '' });
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } catch (err) {
            setError(err.message);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } finally {
            setPasswordLoading(false);
        }
    };

    return (
        <div className="profile-page-wrapper">
            <GlobalHeader />

            <div className="profile-container">
                <div className="profile-header">
                    <h1>Mon Profil</h1>
                </div>

            {message && <div className="success-message">{message}</div>}
            {error && <div className="error-message">{error}</div>}

            <div className="profile-section">
                <h2>Informations personnelles</h2>
                {!editMode ? (
                    <div className="profile-info">
                        <p><strong>Email:</strong> {user?.email}</p>
                        <p><strong>Prénom:</strong> {user?.first_name || 'Non défini'}</p>
                        <p><strong>Nom:</strong> {user?.last_name || 'Non défini'}</p>
                        <p><strong>Rôle:</strong> {user?.role}</p>
                        <button className="btn-secondary" onClick={() => setEditMode(true)}>
                            Modifier
                        </button>
                    </div>
                ) : (
                    <form onSubmit={handleProfileSubmit}>
                        <div className="form-group">
                            <label>Prénom</label>
                            <input
                                type="text"
                                value={formData.firstName}
                                onChange={(e) => setFormData({ ...formData, firstName: e.target.value })}
                            />
                        </div>
                        <div className="form-group">
                            <label>Nom</label>
                            <input
                                type="text"
                                value={formData.lastName}
                                onChange={(e) => setFormData({ ...formData, lastName: e.target.value })}
                            />
                        </div>
                        <div className="form-actions">
                            <button type="submit" className="btn-primary" disabled={loading}>
                                {loading ? 'Enregistrement...' : 'Enregistrer'}
                            </button>
                            <button type="button" className="btn-secondary" onClick={() => setEditMode(false)} disabled={loading}>
                                Annuler
                            </button>
                        </div>
                    </form>
                )}
            </div>

            <div className="profile-section">
                <h2>Changer le mot de passe</h2>
                <form onSubmit={handlePasswordSubmit}>
                    <div className="form-group">
                        <label>Mot de passe actuel</label>
                        <input
                            type="password"
                            value={passwordData.current}
                            onChange={(e) => setPasswordData({ ...passwordData, current: e.target.value })}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>Nouveau mot de passe</label>
                        <input
                            type="password"
                            value={passwordData.new}
                            onChange={(e) => setPasswordData({ ...passwordData, new: e.target.value })}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>Confirmer le nouveau mot de passe</label>
                        <input
                            type="password"
                            value={passwordData.confirm}
                            onChange={(e) => setPasswordData({ ...passwordData, confirm: e.target.value })}
                            required
                        />
                    </div>
                    <button type="submit" className="btn-primary" disabled={passwordLoading}>
                        {passwordLoading ? 'Changement en cours...' : 'Changer le mot de passe'}
                    </button>
                </form>
            </div>
            </div>
        </div>
    );
}

export default ProfilePage;
